import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Divider, LinearProgress, TextField } from 'material-ui';
import PropTypes from 'prop-types';
import KButton from '../KJRN/KButton';
import pallet from '../../constants/colors';
import KTitle from '../KJRN/KTitle';
import PanelMessage from '../panels/PanelMessage';
import { twoFactorLogin } from '../../actions/account/login';

const styles = {
  input: {
    marginTop: 0,
  },
  divider: {
    marginTop: 24,
  },
  cardContent: {
    paddingTop: 0,
    paddingRight: 8,
    paddingLeft: 8,
  },
  root: {
    marginTop: 12,
  },
  message: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  sso: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    marginBottom: 16,
  },
  switch: {
    textAlign: 'center',
    marginTop: 32,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  containerSSO: {
    marginTop: '10vh',
    zIndex: 100,
  },
  container: {
    marginTop: '5vh',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 600,
    width: '100%',
    flexWrap: 'wrap',
    zIndex: 100,
  },
  underlineStyle: {
    borderColor: pallet.primaryColor1,
    color: pallet.primaryColor1,
  },
  titleContainer: {
    display: 'flex',
    flex: '1 1 90%',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingTop: 10,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 24px)',
    padding: 12,
  },
  backContainer: {
    flex: 1,
  },
};

const TwoFactor = ({
  loading,
  securityCode,
  login,
  validationError,
  error,
}) => {
  const [appView, setAppView] = useState(false);
  const [value, setValue] = useState('');

  const validateInput = () => {
    if (appView && value.length !== 10) return false;
    else if (!appView && value.length !== 7) return false;
    return true;
  };

  const handleLogin = () => {
    login(value, appView);
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div style={styles.containerSSO}>
      <KTitle title={<FormattedMessage id={appView ? 'account.mobileAppTitle' : 'account.mobileTitle'} />} style={{ marginBottom: '2vh' }} />
      <div style={styles.inputContainer}>
        <TextField
          type="text"
          hintText={<FormattedMessage id={appView ? 'account.ssn' : 'account.phoneNumber'} />}
          style={styles.root}
          inputStyle={styles.input}
          value={value || ''}
          onKeyDown={handleKeyDown}
          onChange={e => setValue(e.target.value)}
          underlineFocusStyle={styles.underlineStyle}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          fullWidth
          id="phonenumberOrSSN"
        />
      </div>
      {securityCode && (
      <div style={{ fontWeight: 600, textAlign: 'center', marginTop: 16 }}>
        <FormattedMessage id="account.securityCode" />: {securityCode}
      </div>
        )}
      {validationError && validationError.Message &&
        <PanelMessage message={<FormattedMessage id={validationError.Message} />} iconName="warning" type="warning" />
      }
      {error &&
      <PanelMessage message={<FormattedMessage id={error.Message || 'account.login.error.default'} />} iconName="error" type="error" />
      }
      <KButton
        label={<FormattedMessage id="account.login" />}
        disabled={loading}
        containerStyle={{ width: 200, alignSelf: 'center', marginTop: '2vh' }}
        onClick={handleLogin}
      />
      {loading && <LinearProgress mode="indeterminate" />}
      <KButton
        flat
        containerStyle={{ width: 200, alignSelf: 'center', marginTop: '2vh' }}
        label={appView ? <FormattedMessage id="account.mobileTitle" /> : <FormattedMessage id="account.mobileAppButton" />}
        onClick={() => setAppView(!appView)}
        disabled={loading}
      />
    </div>
  );
};

TwoFactor.propTypes = {
  validationError: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  login: PropTypes.func.isRequired,
  securityCode: PropTypes.string,
};

export default connect(
  ({ loginReducer }) => ({ ...loginReducer }),
  dispatch => ({
    login: (identifier, appView) => dispatch(twoFactorLogin(identifier, appView)),
  }),
)(TwoFactor);




// WEBPACK FOOTER //
// ./src/components/account/TwoFactor.js